import { SelectField as RHFSelectField } from "$components/rhf-fields";
import { DoseUnit } from "$global-providers/rxdb-provider/collections/prescription";
import { styled } from "@material-ui/core";
import { defineMessage, type MessageDescriptor, useIntl } from "react-intl";

const WidthMediumSelect = styled(RHFSelectField)(() => ({
  width: "149px",
}));

const doseUnitMessages: Record<DoseUnit, MessageDescriptor> = {
  [DoseUnit.Mg]: defineMessage({
    id: "doseUnit.mg",
    defaultMessage: "mg",
  }),
  [DoseUnit.Micrograms]: defineMessage({
    id: "doseUnit.micrograms",
    defaultMessage: "{value, plural, one {microgram} other {micrograms}}",
  }),
  [DoseUnit.G]: defineMessage({
    id: "doseUnit.g",
    defaultMessage: "g",
  }),
  [DoseUnit.Tablet]: defineMessage({
    id: "doseUnit.tablet",
    defaultMessage: "{value, plural, one {tablet} other {tablets}}",
  }),
  [DoseUnit.Ml]: defineMessage({
    id: "doseUnit.ml",
    defaultMessage: "ml",
  }),
  [DoseUnit.Drop]: defineMessage({
    id: "doseUnit.drops",
    defaultMessage: "{value, plural, one {drop} other {drops}}",
  }),
  [DoseUnit.Puff]: defineMessage({
    id: "doseUnit.puffs",
    defaultMessage: "{value, plural, one {puff} other {puffs}}",
  }),
  [DoseUnit.Unit]: defineMessage({
    id: "doseUnit.units",
    defaultMessage: "{value, plural, one {unit} other {units}}",
  }),
  [DoseUnit.Capsule]: defineMessage({
    id: "doseUnit.capsule",
    defaultMessage: "{value, plural, one {capsule} other {capsules}}",
  }),
  [DoseUnit.Application]: defineMessage({
    id: "doseUnit.application",
    defaultMessage: "{value, plural, one {application} other {applications}}",
  }),
  [DoseUnit.CustomDose]: defineMessage({
    id: "doseUnit.customDose",
    defaultMessage: "{value, plural, one {custom dose} other {custom doses}}",
  }),
  [DoseUnit.Patch]: defineMessage({
    id: "doseUnit.patch",
    defaultMessage: "{value, plural, one {patch} other {patches}}",
  }),
  [DoseUnit.Sachet]: defineMessage({
    id: "doseUnit.sachet",
    defaultMessage: "{value, plural, one {sachet} other {sachets}}",
  }),
  [DoseUnit.Suppository]: defineMessage({
    id: "doseUnit.suppository",
    defaultMessage: "{value, plural, one {suppository} other {suppositories}}",
  }),
  [DoseUnit.Pessary]: defineMessage({
    id: "doseUnit.pessary",
    defaultMessage: "{value, plural, one {pessary} other {pessaries}}",
  }),
  [DoseUnit.Device]: defineMessage({
    id: "doseUnit.device",
    defaultMessage: "{value, plural, one {device} other {devices}}",
  }),
  [DoseUnit.Spray]: defineMessage({
    id: "doseUnit.spray",
    defaultMessage: "{value, plural, one {spray} other {sprays}}",
  }),
  [DoseUnit.Dose]: defineMessage({
    id: "doseUnit.dose",
    defaultMessage: "{value, plural, one {dose} other {doses}}",
  }),
};

export const RHFDoseUnitSelectField: FC<{
  name: string;
  required?: boolean;
}> = ({ name, required }) => {
  const { formatMessage } = useIntl();

  // magic number for now, can make a list of ones to exclude and filter against later
  const options = Object.entries(DoseUnit)
    .slice(0, 11)
    .sort()
    .map(([_key, value]) => ({
      value,
      label: formatMessage(doseUnitMessages[value], { value: 2 }),
    }));

  return (
    <WidthMediumSelect
      hideHelper={true}
      name={name}
      required={required}
      options={options}
    />
  );
};
